module.exports = __webpack_public_path__ + "img/BrandRed.78bca626.svg";